<template>
    <page-view>
        <template slot="action"></template>
        <a-card>
            <expertFees-STable
                    :expertId="expertId"
                    :startDate="startDate"
                    :endDate="endDate"
            />
        </a-card>
    </page-view>
</template>
<script>
import { PageView } from '@/layouts'

import expertFeesSTable from '@/epp/expertmain/expertFees/common/ExpertFeesSTable.vue'

export default {
  name: 'expertFeesProjectList',
  components: {
    expertFeesSTable,
    PageView
  },
  data () {
    return {
      user: this.$ls.get('user'),
      expertId: this.$route.query.expertId,
      startDate: this.$route.query.startDate,
      endDate: this.$route.query.endDate,
    }
  },
  methods: {
  }
}
</script>
